import { WarningFilled } from "@ant-design/icons";
import { Typography } from "antd";
import CustomModal from "components/CustomModal";
import { t } from "i18next";

// UI dùng chung cho case "PTVC đang chọn không còn hợp lệ" — vừa hiện real-time khi giá trị đơn
// thay đổi, vừa hiện lúc bấm "Tạo đơn" (ModalCreateOrder tái dùng bằng customIcon/message riêng
// để tránh lặp UI).
const InvalidShippingTypePopup = ({ visible, onClose, message }) => (
  <CustomModal
    visible={visible}
    selfVisibleControlled={false}
    onCancel={onClose}
    onOke={onClose}
    footer={false}
    centered={true}
    hideCancelButton={true}
    okeButtonLabel={t("v2.cart.shippingPolicy.editShippingTypeButton")}
    customIcon={<WarningFilled style={{ fontSize: 48, color: "#ff4d4f" }} />}
    title={<b>{t("v2.cart.shippingPolicy.invalidShippingTypeTitle")}</b>}
    message={<Typography.Text>{message}</Typography.Text>}
  />
);

export default InvalidShippingTypePopup;
